import React from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import SelectSearch from 'react-select-search';
import { makeSelectSelectedVersion } from './selectors';
import { selectVersion, carLoaded } from './actions';
import { FlexSection } from '../UIKit';

class Version extends React.Component {
  constructor(props) {
    super(props);

    this.resetCar = this.resetCar.bind(this);
    this.selectVersion = this.selectVersion.bind(this);
  }

  selectVersion = value => {
    this.props.versionSelected(value);
  };

  resetCar = () => {
    this.selectVersion(null)
    this.props.resetCar();
  };

  renderVersion(props, option, snapshot, className) {
    return (
      <button {...props} className={className} type="button">
          <span>{option.name}</span>
      </button>
    );
  }

  renderSelectedVersion = (props, option, className) => {
    return (
      <>
        <input {...props} className={className} value={option.displayValue} />
        {option.displayValue &&
          <i
            className="os-icon os-icon-close small position-absolute"
            style={{
              position: "absolute",
              top: "calc(50% - 6px)",
              right: "39px",
              fontSize: ".8rem",
              cursor: "pointer",
            }}
            title="Cancella selezione"
            onClick={this.resetCar}
          />
        }
      </>
    );
  }

  render() {
    const { isLoading, title, placeholder, versions, selected } = this.props;
    return (
      <div id="CarSelectorVersion" className={isLoading ? 'is-loading' : null}>
        <FlexSection
          title={title}
          children={
            <>
            <SelectSearch
              name="model-brand"
              className="select-search-box select-search-box--multiple"
              value={selected}
              onChange={this.selectVersion}
              options={versions}
              placeholder={placeholder}
              renderOption={this.renderVersion}
              renderValue={this.renderSelectedVersion}
              disabled={isLoading || versions.length < 1}
              search
            />
            </>
          }
        />
      </div>
    );
  }
}

Version.defaultProps = {
  versions: [],
  placeholder: 'Seleziona',
  errors: {},
  isLoading: true,
};
Version.propTypes = {
  title: PropTypes.string,
  selected: PropTypes.string,
  placeholder: PropTypes.string,
  versions: PropTypes.array,
  errors: PropTypes.object,
  versionSelected: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
};

export function mapDispatchToProps(dispatch) {
  return {
    versionSelected: model => dispatch(selectVersion(model)),
    resetCar: () => dispatch(carLoaded({})),
  };
}

const mapStateToProps = createStructuredSelector({
  selected: makeSelectSelectedVersion()
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Version);
